import {LIVE_AFREECATV_DOMAIN} from 'constants/config';
import client from 'lib/api/client';

/**
 * 구독 세션 API
 */
export default async function checkSubscriptionSession(
  body: ICheckSubscriptionSession,
) {
  const form = new FormData();
  Object.entries(body).forEach(([key, val]) => {
    form.append(key, JSON.stringify(val));
  });

  const response = await client.post<ICheckSubscriptionSessionResponse>(
    LIVE_AFREECATV_DOMAIN + '/api/private_auth.php',
    form,
    {
      withCredentials: true,
    },
  );
  return response.data;
}

export interface ICheckSubscriptionSession {
  type: 'live' | 'vod';
  strm_id: string;
  title_no: number;
  url: string;
  file_order: number;
}

export type ICheckSubscriptionSessionResponse =
  | ICheckSubscriptionSessionSuccessResponse
  | ICheckSubscriptionSessionFailResponse;

export interface ICheckSubscriptionSessionSuccessResponse {
  result: 1;
  data: {
    signed_cookie: string;
  };
}

export interface ICheckSubscriptionSessionFailResponse {
  result: -1;
  data: {
    code: number;
    message: string;
  };
}
